
import './App.css';
import { Routes, Route } from "react-router-dom";
import LoginPage from './Pages/LoginPage';
import NewLogin from './Login2'
import HomePage from './Pages/HomePage';
import EmployeeListPage from './Pages/EmployeeListPage';
import EmplRegistrationPage from './Pages/EmplRegistrationPage';
import LeaveManagementPage from './Pages/LeaveManagementPage';
import LeaveApprovalPage from './Pages/LeaveApprovalPage';
import LeaveRejoinPage from './Pages/LeaveRejoinPage';
import ViewEmpPage from './Pages/ViewEmpPage';
import EmployeeEditPage from './Pages/EmployeeEditPage';
import CreateAllowance from './Components/Employee/CreateAllowance/CreateAllowance';
import LeaveCatPage from './Pages/LeaveCatPage';
import LeaveAllotmentPage from './Pages/LeaveAllotmentPage';
import LeaveApplicationPage from './Pages/LeaveApplicationPage';
import AttendanceEvaluationPage from './Pages/AttendanceEvaluationPage';
import TimesheetPage from './Pages/TimesheetPage';
import PayrollManagementPage from './Pages/PayrollManagementPage';
import HolidayManagementPage from './Pages/HolidayManagementPage';
import AttendancePage from './Pages/AttendancePage';
import LeavePage from './Pages/LeavePage';
import BigCalendar from './Components/Ghant/BigCalendar/BigCalendar';
import TaskGant from './Components/Ghant/TaskGant/TaskGant';
import HomeNew from './Pages/HomeNew';
import MachineValidation from './MachineValidation';
import ProtectedRoute from './ProtectedRoute';
import ProtectedMachine from './ProtectedMachine';
import Wps from './Components/Wps/Wps';
import MainPayroll from './Components/Payroll/MainPayroll';




function App() {
  return (
    <Routes>

      <Route index element={<MachineValidation />} />
      <Route path='login' element={<NewLogin />} />

      <Route element={<ProtectedMachine />}>

        <Route element={<ProtectedRoute />}>

          <Route path="admin" element={<HomeNew />} >
            <Route path="home" element={<HomePage />} />
            <Route path="attendancePage" element={<AttendancePage />} />
            <Route path="leavePage" element={<LeavePage />} />
            <Route path="emp_list" element={<EmployeeListPage />} />
            <Route path="emp_list/emp_reg" element={<EmplRegistrationPage />} />
            <Route path="emp_reg" element={<EmplRegistrationPage />} />
            <Route path="createAllowance" element={<CreateAllowance />} />
            <Route path="admin/emp_list/emp_edit/createAllowance" element={<CreateAllowance />} />
            <Route path="emp_reg/createAllowance" element={<CreateAllowance />} />
            <Route path="emp_list/emp_edit/:id" element={<EmployeeEditPage />} />
            <Route path="emp_list/view_emp/emp_edit/:id" element={<EmployeeEditPage />} />
            <Route path="emp_list/view_emp/:id" element={<ViewEmpPage />} />
            <Route path="leavemanagement" element={<LeaveManagementPage />} />
            <Route path="leaveallotment" element={<LeaveAllotmentPage />} />
            <Route path="leaveapplication" element={<LeaveApplicationPage />} />
            <Route path="leaveapproval" element={<LeaveApprovalPage />} />
            <Route path="leaverejoin" element={<LeaveRejoinPage />} />
            <Route path="leavecat" element={<LeaveCatPage />} />
            <Route path="atdcevaluation" element={<AttendanceEvaluationPage />} />
            <Route path="timesheet" element={<TimesheetPage />} />
            <Route path="payroll" element={<PayrollManagementPage />} />
            <Route path="payrollMain" element={<MainPayroll />} />
            <Route path="holiday" element={<HolidayManagementPage />} />
            <Route path="bigCalendar" element={<BigCalendar />} />
            <Route path="taskGant" element={<TaskGant />} />
            <Route path="wps" element={<Wps />} />
          </Route>

        </Route>
      </Route>

    </Routes>

  );
}

export default App;
